function selectVariationAttributes(form, attributes) {
    const entries = Object.entries(attributes);
    let index = 0;
    let changed = false;
    let selectBox;

    const applyNext = () => {
        if (index >= entries.length) {
            if (!changed) {
                jQuery(form).trigger("check_variations");
            }
            return;
        }

        const [name, value] = entries[index];
        const select = form.querySelector(
            `select[name="attribute_${name}"]`
        );

        index++;

        if (!select) {
            applyNext();
            return;
        }

        if (select.value !== value) {
            changed = true;
            select.value = value;

            if('pa_taille' !== name) {
                selectBox = jQuery(select).parent().find('.select_box')

                if(selectBox.length) {
                    selectBox?.find('[data-value="' + value + '"]')?.click();
                } else {
                    select.dispatchEvent(new Event("change", {bubbles: true}));
                }
            } else {
                select.dispatchEvent(new Event("change", {bubbles: true}));
            }
        }

        applyNext();
    };

    applyNext();
}

export class ProductAvailableImmediately {
    constructor(selectInput) {
        this.selectInput = selectInput;
        this.attributes = JSON.parse(selectInput.dataset.attributes);
        this.form = document.querySelector("form.variations_form");

        this.init();
    }

    init() {
        this.selectInput.addEventListener("click", () => {
            if (!this.form) return;

            if (this.isAlreadySelected()) {
                this.closeAside();
                return;
            }

            this.setLoading(true);
            selectVariationAttributes(this.form, this.attributes);
        });

        jQuery(this.form).on("found_variation", () => {
            this.setLoading(false);
            this.closeAside();
        });
    }

    isAlreadySelected() {
        return Object.entries(this.attributes).every(([name, value]) => {
            const select = this.form.querySelector(
                `select[name="attribute_${name}"]`
            );

            return select && select.value === value;
        });
    }

    setLoading(state) {
        this.selectInput.classList.toggle("is-loading", state);

        this.selectInput
            .closest(".aside-product-available-immediately__list")
            ?.querySelectorAll(".aside-product-available-immediately__select")
            .forEach((btn) => {
                if (btn !== this.selectInput) {
                    btn.disabled = state;
                }
            });
    }

    closeAside() {
        const closeButton = this.selectInput
            .closest(".custom-aside")
            ?.querySelector(".custom-aside__close");

        closeButton?.click();
    }
}

export class ProductAvailableImmediatelyBuyNow {
    constructor(buyNowButton) {
        this.buyNowButton = buyNowButton;
        this.attributes = JSON.parse(buyNowButton.dataset.attributes);
        this.form = document.querySelector("form.variations_form");

        this.init();
    }

    init() {
        this.buyNowButton.addEventListener("click", () => {
            if (!this.form) return;

            this.setLoading(true);

            jQuery(this.form).one("found_variation", () => {
                const submit = () => {
                    const submitButton = this.form.querySelector(".single_add_to_cart_button");
                    submitButton?.click();
                    this.setLoading(false);
                };

                if (this.form.querySelector("#yith-wapo-container")) {
                    jQuery(this.form).one("yith-wapo-after-reload-addons", submit);
                } else {
                    submit();
                }
            });

            selectVariationAttributes(this.form, this.attributes);
        });
    }

    setLoading(state) {
        this.buyNowButton.classList.toggle("is-loading", state);
        this.buyNowButton.disabled = state;
    }
}

class ProductAvailableImmediatelyAccordion {
    constructor(list) {
        this.list = list;
        this.items = Array.from(
            list.querySelectorAll(".aside-product-available-immediately__item")
        );

        this.items.forEach((item) => {
            const header = item.querySelector(".aside-product-available-immediately__header");

            header.addEventListener("click", () => this.toggle(item));
        });
    }

    toggle(item) {
        const isOpen = item.classList.contains("isOpen");

        this.items.forEach((otherItem) => {
            if (otherItem !== item) {
                otherItem.classList.remove("isOpen");
            }
        });

        item.classList.toggle("isOpen", !isOpen);
    }
}

export const setupProductAvailableImmediately = () => {
    jQuery("body").on("yith_wccl_form_initialized", function () {
        document
            .querySelectorAll(".aside-product-available-immediately__select")
            .forEach((selectButton) => {
                new ProductAvailableImmediately(selectButton);
            });

        document
            .querySelectorAll(".aside-product-available-immediately__add-to-cart")
            .forEach((buyNowButton) => {
                new ProductAvailableImmediatelyBuyNow(buyNowButton);
            });

        document
            .querySelectorAll(".aside-product-available-immediately__list")
            .forEach((list) => {
                new ProductAvailableImmediatelyAccordion(list);
            });
    });
};
